import ahsanImage from "@/assets/ahsan-sajid.png";

export const StartupFailureFounderQuote = () => {
  return (
    <div className="bg-card border border-border rounded-xl p-6 sm:p-8">
      <div className="flex flex-col sm:flex-row gap-6 items-start">
        <img 
          src={ahsanImage} 
          alt="Ahsan Sajid" 
          className="w-16 h-16 rounded-full object-cover border-2 border-primary/20 shrink-0"
        />
        <div>
          <blockquote className="text-lg sm:text-xl text-foreground italic mb-4">
            "I've seen brilliant founders crash their startups because they couldn't let go. They'll spend 16 hours fixing a bug their junior dev could handle, while the company's strategic decisions pile up. The irony? They think they're being responsible, but they're actually abandoning their real job—leading."
          </blockquote>
          <div>
            <p className="font-semibold text-foreground">Ahsan Sajid</p>
            <p className="text-sm text-muted-foreground">Owner, IT Dukes</p>
          </div>
        </div>
      </div>
    </div>
  );
};
